export const SENT_AND_RECEIVED = ""
export const SENT = "sent"
export const RECEIVED = "received"

export const SENT_RECEIVED_SORT_OPTIONS = [
  {value: SENT_AND_RECEIVED, label: "recognition.account.recognition.sortBy.options.sentAndReceived"},
  {value: SENT, label: "recognition.account.recognition.sortBy.options.sent"},
  {value: RECEIVED, label: "recognition.account.recognition.sortBy.options.received"}
]

export default {
  SENT_AND_RECEIVED,
  SENT,
  RECEIVED,
  OPTIONS: SENT_RECEIVED_SORT_OPTIONS
}
